import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Container, Grid, List, TextField, Typography } from '@iho-design-system/Loader';

const Banner = ({ props, selectedQuestionProps }) => {

    /*
        - defaultData
    */
    const [searchKey, setSearchKey] = React.useState('');
    const [searchResult, setSearchResult] = React.useState([]);
    const [searchResultStatus, setSearchResultStatus] = React.useState(false);
    const [platformQuestions, setPlatformQuestions] = React.useState([]);

    React.useEffect(() => {
        if (props.platformQuestions.status === 200) {
            setPlatformQuestions(props.platformQuestions.data);
        }
    }, [props]);

    /*
        - search
    */
    const search = (value) => {
        setSearchKey(value);
        let arrayHelper = [];
        if (searchKey.length > 0 && value !== '') {
            platformQuestions.forEach((parentObj) => {
                parentObj.Contents.forEach((obj) => {
                    if (obj.Title.indexOf(searchKey) > -1) {
                        setSearchResultStatus(true);
                        arrayHelper.push(obj)
                        setSearchResult(arrayHelper)
                    }
                });
            });
        } else {
            setSearchResultStatus(false);
        }
    }

    /*
        - setSelectedQuestion
    */
    const setSelectedQuestion = (selectedQuestion) => {
        selectedQuestionProps(selectedQuestion);
        setSearchKey('');
        setSearchResultStatus(false);
    }

    return (

        <React.Fragment>

            <Box
                className={`postion-relative`}
                ms={{
                    marginBottom: '96px'
                }}>
                <Box
                    className={`w-100 position-relative`}
                    ms={{
                        height: '300px',
                        zIndex: '1',
                        '&:after': {
                            content: '""',
                            width: '200%',
                            height: '200%',
                            backgroundColor: '#0E4BBB',
                            borderRadius: '50%',
                            transform: 'translate(0, -50%)',
                            position: 'absolute',
                            right: '-50%',
                            zIndex: '-1',
                            '@media(max-width:1200px)': {
                                borderRadius: '35%',
                            }
                        }
                    }}>
                    <Box
                        className={`w-100 position-absolute transform-center`}>
                        <Typography
                            component='h1'
                            className={`d-block text-center text-white`}
                            ms={{
                                fontSize: '40px !important',
                                '@media(max-width:576px)': {
                                    fontSize: '24px !important',
                                }
                            }}>
                            مرکز پشتیبانی ایران هتل آنلاین
                        </Typography>
                        <Typography
                            component='h5'
                            className={`d-block text-center text-white`}
                            ms={{
                                marginTop: '16px'
                            }}>
                            به کمک نیاز دارید؟
                            ما برای شما اینجا هستیم!
                        </Typography>
                    </Box>
                    <Box
                        className={`px-xl position-absolute right-0 left-0`}
                        ms={{
                            bottom: '-50px',
                            zIndex: '1'
                        }}>
                        <Container
                            size='md'>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        size='col-12'>
                                        <Box
                                            className={`p-sm rounded-sm position-relative`}
                                            ms={{
                                                backgroundColor: 'var(--white)',
                                                boxShadow: 'var(--shadow-dark)'
                                            }}>
                                            <Grid>
                                                <Grid.Wrapper>
                                                    <Grid.Item
                                                        size='col-8 sm-10'>
                                                        <TextField
                                                            onChange={search}
                                                            variant='filled'
                                                            placeholder='سوال خود را بنویسید ...'
                                                            size='lg'
                                                            value={searchKey} />
                                                    </Grid.Item>
                                                    <Grid.Item
                                                        size='col-4 sm-2'>
                                                        <Button
                                                            className='w-100'
                                                            color='warning'
                                                            size='lg'>
                                                            جستجو
                                                        </Button>
                                                    </Grid.Item>
                                                </Grid.Wrapper>
                                            </Grid>
                                            {searchResultStatus &&
                                                <Box
                                                    className={`w-100 p-lg position-absolute right-0 rounded-sm`}
                                                    ms={{
                                                        backgroundColor: 'var(--white)',
                                                        boxShadow: 'var(--shadow-dark)',
                                                        top: '88px'
                                                    }}>
                                                    <List>
                                                        {searchResult.map((obj, index) => {
                                                            return (
                                                                <List.Item
                                                                    onClick={() => setSelectedQuestion(obj.Id)}
                                                                    key={index}
                                                                    className={`py-sm border-solid-bottom border-medium pointer`}
                                                                    ms={{
                                                                        '&:hover': {
                                                                            fontWeight: 'bold'
                                                                        },
                                                                        '&:last-child': {
                                                                            border: 'none'
                                                                        }
                                                                    }}>
                                                                    {obj.Title}
                                                                </List.Item>
                                                            )
                                                        })}
                                                    </List>
                                                </Box>
                                            }
                                        </Box>
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Container>
                    </Box>
                </Box>
            </Box>

        </React.Fragment>

    );

}

export default Banner;